import { render, staticRenderFns } from "./dadutouMb.vue?vue&type=template&id=c3a65c48&scoped=true&"
import script from "./dadutouMb.vue?vue&type=script&lang=js&"
export * from "./dadutouMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a65c48",
  null
  
)

export default component.exports